/**
 * Customer-related GraphQL queries and mutations
 * Handles customer authentication, token management, and profile updates
 */

import { gql } from '@apollo/client/core'

const CUSTOMER_ACCESS_TOKEN_CREATE = gql`
  mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`

const UPDATE_CUSTOMER_DETAILS = gql`
  mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {
    customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
      }
      customerUserErrors {
        code
      }
    }
  }
`

const CUSTOMER_PASSWORD_RESET = gql`
  mutation customerReset($id: ID!, $input: CustomerResetInput!) {
    customerReset(id: $id, input: $input) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
      }
    }
  }
`

const CUSTOMER_PASSWORD_RECOVER = gql`
  mutation customerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        code
      }
      userErrors {
        field
        message
      }
    }
  }
`

/** END OF QUERIES */

interface CreateCustomerTokenResponse {
  customerAccessTokenCreate: {
    customerAccessToken: {
      accessToken: string
      expiresAt: string
    }
  }
}

/**
 * Handles the GraphQL response
 */
const customerToken = (input: { data: CreateCustomerTokenResponse }) => {
  if (!input.data || !input.data.customerAccessTokenCreate) {
    throw new Error('Response data empty.')
  }
  const payload = input.data.customerAccessTokenCreate.customerAccessToken
  return {
    accessToken: payload.accessToken,
    expiresAt: payload.expiresAt
  }
}

export {
  customerToken,
  UPDATE_CUSTOMER_DETAILS,
  CUSTOMER_ACCESS_TOKEN_CREATE,
  CUSTOMER_PASSWORD_RECOVER,
  CUSTOMER_PASSWORD_RESET
}
